import { render, staticRenderFns } from "./ListingSocialMedia.vue?vue&type=template&id=b21168e8&"
import script from "./ListingSocialMedia.vue?vue&type=script&lang=js&"
export * from "./ListingSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports